import http from "../http-common";

export default class CventMemberType {
  getConvertedMember(memberType: string, isActive: boolean, eCode: string, isFaculty: boolean, regType: string) {
    let url = `/cvent-page/convert-member-type/${memberType}/${isActive}/${eCode}/${isFaculty}/${regType}`;

    return http.get(url);
  }
}